<template>
  <div class="contact">
    <!-- 页面标题 -->
    <section class="page-hero">
      <div class="container">
        <h1 class="page-title">联系我们</h1>
        <p class="page-subtitle">我们期待与您的合作，共创美好未来</p>
      </div>
    </section>

    <!-- 联系信息 -->
    <section class="contact-info section">
      <div class="container">
        <div class="contact-grid">
          <div class="contact-form-section">
            <h2 class="section-title">发送消息</h2>
            <form class="contact-form" @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group">
                  <label for="name">姓名 *</label>
                  <input
                    type="text"
                    id="name"
                    v-model="form.name"
                    required
                    placeholder="请输入您的姓名"
                  >
                </div>
                <div class="form-group">
                  <label for="company">公司名称</label>
                  <input
                    type="text"
                    id="company"
                    v-model="form.company"
                    placeholder="请输入公司名称"
                  >
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="email">邮箱 *</label>
                  <input
                    type="email"
                    id="email"
                    v-model="form.email"
                    required
                    placeholder="请输入您的邮箱"
                  >
                </div>
                <div class="form-group">
                  <label for="phone">电话</label>
                  <input
                    type="tel"
                    id="phone"
                    v-model="form.phone"
                    placeholder="请输入您的电话"
                  >
                </div>
              </div>

              <div class="form-group">
                <label for="subject">主题 *</label>
                <select id="subject" v-model="form.subject" required>
                  <option value="">请选择咨询主题</option>
                  <option value="product">产品咨询</option>
                  <option value="service">服务咨询</option>
                  <option value="cooperation">合作洽谈</option>
                  <option value="support">技术支持</option>
                  <option value="other">其他</option>
                </select>
              </div>

              <div class="form-group">
                <label for="message">留言内容 *</label>
                <textarea
                  id="message"
                  v-model="form.message"
                  required
                  rows="6"
                  placeholder="请详细描述您的需求..."
                ></textarea>
              </div>

              <button type="submit" class="btn btn-primary" :disabled="submitting">
                {{ submitting ? '发送中...' : '发送消息' }}
              </button>
            </form>
          </div>

          <div class="contact-details-section">
            <h2 class="section-title">联系方式</h2>
            <div class="contact-details">
              <div class="contact-item" v-for="item in contactDetails" :key="item.id">
                <div class="contact-icon">{{ item.icon }}</div>
                <div class="contact-content">
                  <h3 class="contact-title">{{ item.title }}</h3>
                  <p class="contact-text">{{ item.content }}</p>
                  <p class="contact-extra" v-if="item.extra">{{ item.extra }}</p>
                </div>
              </div>
            </div>

            <div class="office-hours">
              <h3 class="hours-title">营业时间</h3>
              <div class="hours-content">
                <div class="hours-item">
                  <span class="hours-day">周一至周五</span>
                  <span class="hours-time">9:00 - 18:00</span>
                </div>
                <div class="hours-item">
                  <span class="hours-day">周六</span>
                  <span class="hours-time">10:00 - 16:00</span>
                </div>
                <div class="hours-item">
                  <span class="hours-day">周日</span>
                  <span class="hours-time">休息</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 地图区域 -->
    <section class="map-section">
      <div class="map-container">
        <div class="map-placeholder">
          <div class="map-content">
            <div class="map-icon">🗺️</div>
            <h3>公司位置</h3>
            <p>北京市朝阳区XXX大厦15层</p>
            <p class="map-note">* 实际项目中可以集成百度地图或高德地图API</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 其他联系方式 -->
    <section class="social-contact section" style="background: #f8f9fa;">
      <div class="container">
        <div class="section-title">
          <h2>其他联系方式</h2>
          <p>选择最便捷的方式与我们取得联系</p>
        </div>
        <div class="social-grid">
          <div class="social-item" v-for="social in socialContacts" :key="social.id">
            <div class="social-icon">{{ social.icon }}</div>
            <h3 class="social-title">{{ social.title }}</h3>
            <p class="social-description">{{ social.description }}</p>
            <a href="#" class="social-link">{{ social.action }}</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功提示 -->
    <div v-if="showSuccess" class="success-modal" @click="showSuccess = false">
      <div class="success-content" @click.stop>
        <div class="success-icon">✅</div>
        <h3>消息发送成功！</h3>
        <p>我们已收到您的消息，将在24小时内回复您。</p>
        <button class="btn btn-primary" @click="showSuccess = false">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      },
      submitting: false,
      showSuccess: false,
      contactDetails: [
        {
          id: 1,
          icon: '📍',
          title: '公司地址',
          content: '北京市朝阳区XXX大厦15层',
          extra: '邮编：100020'
        },
        {
          id: 2,
          icon: '📞',
          title: '联系电话',
          content: '+86 400-123-4567',
          extra: '服务热线：7×24小时'
        },
        {
          id: 3,
          icon: '✉️',
          title: '邮箱地址',
          content: 'contact@yourcompany.com',
          extra: 'support@yourcompany.com'
        },
        {
          id: 4,
          icon: '💬',
          title: '在线客服',
          content: 'QQ：123456789',
          extra: '微信：yourcompany_service'
        }
      ],
      socialContacts: [
        {
          id: 1,
          icon: '📱',
          title: '微信咨询',
          description: '扫描二维码添加企业微信',
          action: '添加微信'
        },
        {
          id: 2,
          icon: '📞',
          title: '电话咨询',
          description: '专业顾问为您提供一对一服务',
          action: '立即拨打'
        },
        {
          id: 3,
          icon: '💬',
          title: '在线客服',
          description: '工作时间内实时响应您的咨询',
          action: '开始对话'
        },
        {
          id: 4,
          icon: '📧',
          title: '邮件咨询',
          description: '详细需求可发送邮件给我们',
          action: '发送邮件'
        }
      ]
    }
  },
  methods: {
    async submitForm () {
      this.submitting = true

      // 模拟表单提交
      await new Promise(resolve => setTimeout(resolve, 2000))

      this.submitting = false
      this.showSuccess = true

      // 重置表单
      this.form = {
        name: '',
        company: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.page-hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 120px 0 80px;
  text-align: center;
}

.page-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
}

.page-subtitle {
  font-size: 20px;
  opacity: 0.9;
}

/* 联系信息 */
.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.section-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 32px;
  color: #333;
}

/* 联系表单 */
.contact-form {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

/* 联系详情 */
.contact-details {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 32px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 32px;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-icon {
  font-size: 24px;
  min-width: 40px;
  text-align: center;
}

.contact-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.contact-text {
  color: #666;
  margin-bottom: 4px;
}

.contact-extra {
  color: #999;
  font-size: 14px;
}

/* 营业时间 */
.office-hours {
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.hours-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.hours-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.hours-item:last-child {
  border-bottom: none;
}

.hours-day {
  font-weight: 500;
  color: #333;
}

.hours-time {
  color: #667eea;
}

/* 地图区域 */
.map-section {
  height: 400px;
  background: #f8f9fa;
}

.map-container {
  height: 100%;
  position: relative;
}

.map-placeholder {
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.map-content {
  text-align: center;
}

.map-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.map-content h3 {
  font-size: 24px;
  margin-bottom: 12px;
}

.map-content p {
  font-size: 16px;
  margin-bottom: 8px;
}

.map-note {
  font-size: 14px;
  opacity: 0.8;
  font-style: italic;
}

/* 社交联系方式 */
.social-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 32px;
  margin-top: 60px;
}

.social-item {
  background: white;
  padding: 32px 24px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.social-item:hover {
  transform: translateY(-4px);
}

.social-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.social-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.social-description {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.social-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.social-link:hover {
  color: #764ba2;
}

/* 成功提示模态框 */
.success-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.success-content {
  background: white;
  padding: 40px;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  margin: 20px;
}

.success-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.success-content h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 16px;
}

.success-content p {
  color: #666;
  margin-bottom: 24px;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-title {
    font-size: 36px;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .contact-form,
  .contact-details,
  .office-hours {
    padding: 24px;
  }

  .social-grid {
    grid-template-columns: 1fr;
  }

  .map-section {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .success-content {
    padding: 24px;
    margin: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue